import React from "react";
import "./officerCard.scss";
function OfficerCard({ officer, nep }) {
  console.log("officer", officer);
  return (
    <>
      <div className="Imgs">
        <img src={officer.featured_image} alt={officer.file_alt || officer.name} />
      </div>
      <div className="GDetails">
        <h3>
          <b>{nep ? "नाम" : "Name"} : </b>
          {nep ? officer.name_nepali : officer.name}
        </h3>
        <p>
          {officer.position && <b>{nep ? "पद" : "Position"} : </b>}

          {nep ? officer.position_np : officer.position}
        </p>
        <p>
          {officer.contact && <b>{nep ? "सम्पर्क नम्बर" : "Contact"} : </b>}

          {officer.contact}
        </p>
        {officer.type == "Information" ||
        officer.type == "company-secretary" ? (
          ""
        ) : officer.type == "Compliance" ? (
          ""
        ) : (
          <p>
            {officer.mobile && <b>{nep ? "मोबाइल नम्बर" : "Mobile No"} : </b>}

            {officer.mobile}
          </p>
        )}

        <p>
          {officer.email && <b>{nep ? "इमेल" : "Email"} : </b>}

          {officer.email}
        </p>
      </div>
    </>
  );
}

export default OfficerCard;
